<template>
  <div @click="closeDialog" class="toast-container">
    <span class="toast">{{ this.msg }}</span>
  </div>
</template>

<script>
  export default {
    name: 'ToastTip',
    data() {
      return {
        timeoutID: '',
      }
    },
    props: {
      msg: String
    },
    methods: {
      closeDialog() {
        this.$emit('close')
        clearTimeout(this.timeoutID)
      },
    },
    mounted() {
      window.setTimeout(() => {}, 3000)
      this.timeoutID = window.setTimeout(() => {
        this.$emit('close')
      }, 3000)
    },
  }
</script>

<style lang="less" scoped>
  @keyframes slideout {
    from {
      transform: translateY(0%);
    }
    to {
      transform: translateY(-60px);
      opacity: 0;
    }
  }

  .toast-container {
    position: absolute;
    height: 100vh;
    width: 100vw;
    z-index: 999;
    top: 0;
    text-align: center;
    .toast {
      animation: slideout 0.4s 2.7s;
      position: relative;
      top: 48%;
      display: inline-block;
      padding: 0 15px;
      border-radius: 5px;
      box-shadow: 0 0 25px rgba(0, 0, 0, 0.5);
      background-color: rgba(0, 0, 0, 0.8);
      color: white;
      font-size: 14px;
      line-height: 40px;
    }
  }
</style>
